'use client'

import { fetchDeepLink } from '@services/fetchDeepLink'
import React, { useEffect, useState } from 'react'
import { Overflow } from '@enums/OverflowTypes'
import { onDownloadApp } from '@components/MainWidget/common/helper'
import { widgetJourney } from '@configs/segmentEvents.config'
import DesktopChallanModal from './Desktop/DesktopChallanModal'
import MobileChallanModal from './Mobile/MobileChallanModal'
import { getWidgetId } from '../../ChallanWidgetModals/constants'
import { DEFAULT_FINAL_MODAL_VARIATION, FALLBACK_MOBILE_MODAL_DATA, FALLBACK_DESKTOP_MODAL_DATA } from '../constants'

interface ChallanAppRedirectWrapperProps {
  challanFinalScreenData: any
  isMobile: boolean
  regNum: string
  mobileNo: string
  vehicleInfoData: Record<string, any>
  segmentEventCommonProperties: Record<string, string> | null
  setShowMobileChallanModal: Function
  isBottomFloater: boolean
  onHide: Function
  showMwebChallanModal: boolean
  setShowMwebChallanModal: Function
  widgetType: string
}

const ChallanAppRedirectWrapper: React.FC<ChallanAppRedirectWrapperProps> = ({
  challanFinalScreenData,
  isMobile,
  regNum,
  mobileNo,
  vehicleInfoData,
  segmentEventCommonProperties,
  setShowMobileChallanModal,
  isBottomFloater,
  onHide,
  showMwebChallanModal,
  setShowMwebChallanModal,
  widgetType,
}) => {
  const [downloadUrl, setDownloadUrl] = useState('')

  useEffect(() => {
    if (showMwebChallanModal || isMobile) {
      document.documentElement.style.overflowY = Overflow.Hidden
    }

    // push fake history to history
    if (showMwebChallanModal) {
      window.history.pushState({ modal: true }, '')
    }
  }, [showMwebChallanModal, isMobile])

  // Handle browser back button
  useEffect(() => {
    const onPop = () => {
      if (showMwebChallanModal) {
        handleMobileChallanModalClose()
      }
    }
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [showMwebChallanModal])

  useEffect(() => {
    if (!isMobile) {
      const fetchData = async (regNo, widgetType, mobileNo, selectedProvider) => {
        const deepLink = await fetchDeepLink({ regNo, widgetType, mobileNo, selectedProvider })
        setDownloadUrl(deepLink)
      }

      void fetchData(regNum, widgetType, mobileNo, vehicleInfoData?.selectedProvider)
    } else setShowMwebChallanModal(true)
  }, [])

  useEffect(() => {
    const setWidgetDisplay = (display: string) => {
      const widgetElements = document.querySelectorAll(getWidgetId(widgetType))
      widgetElements.forEach(widgetElement => {
        const element = widgetElement as HTMLElement
        element.style.display = display
      })
    }

    if (isBottomFloater) {
      setWidgetDisplay('none')
    } else {
      setWidgetDisplay('')
    }

    return () => {
      setWidgetDisplay('')
    }
  }, [isBottomFloater])

  const handleMobileChallanModalClose = () => {
    if (onHide) {
      onHide()
    }

    document.documentElement.style.overflowY = Overflow.Scroll
    setShowMwebChallanModal(false)
  }

  return (
    <>
      {showMwebChallanModal && isMobile && (
        <MobileChallanModal
          regNum={regNum}
          {...((challanFinalScreenData?.mobileScreenData?.title
            ? challanFinalScreenData?.mobileScreenData
            : challanFinalScreenData?.mobileScreenData?.[DEFAULT_FINAL_MODAL_VARIATION]) || FALLBACK_MOBILE_MODAL_DATA)}
          onSubmit={() => {
            void onDownloadApp({
              regNo: vehicleInfoData?.reg_number,
              widgetType,
              phone: vehicleInfoData?.mobile_number,
              vehicleData: vehicleInfoData?.vehicleInfo,
              providerData: vehicleInfoData?.selectedProvider,
              segmentEventCommonProperties: {
                page_type: `${widgetJourney?.[widgetType]}_check_variation_${DEFAULT_FINAL_MODAL_VARIATION}`,
                journey: widgetJourney?.[widgetType],
              },
            })
          }}
          segmentEventCommonProperties={segmentEventCommonProperties}
          widgetType={widgetType}
          vehicleInfoData={vehicleInfoData}
          variation={DEFAULT_FINAL_MODAL_VARIATION}
        />
      )}
      {!isMobile && (
        <DesktopChallanModal
          show
          downloadUrl={downloadUrl}
          regNum={regNum}
          {...((challanFinalScreenData?.desktopScreenData?.title
            ? challanFinalScreenData?.desktopScreenData
            : challanFinalScreenData?.desktopScreenData?.[DEFAULT_FINAL_MODAL_VARIATION]) ||
            FALLBACK_DESKTOP_MODAL_DATA)}
          onClose={() => {
            setShowMobileChallanModal(false)
            document.documentElement.style.overflowY = Overflow.Scroll
          }}
          segmentEventCommonProperties={segmentEventCommonProperties}
          widgetType={widgetType}
          vehicleInfoData={vehicleInfoData}
          variation={DEFAULT_FINAL_MODAL_VARIATION}
        />
      )}
    </>
  )
}

export default ChallanAppRedirectWrapper
